export interface TripMonitoringState {
  estimatedArrivalTime: Date;
  duration: number;
}

export const initialTripMonitoringState: TripMonitoringState = {
  estimatedArrivalTime: null,
  duration: 0,
};
